import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit';

import { Link } from '../../../Link';
import * as styles from './BuilderStatsField.css';

interface IBuilderStatField {
  statusText: string;
  url: string;
  text: string;
  onClick?(e?: React.MouseEvent<HTMLAnchorElement>): void;
}

export const BuilderStat = (props: IBuilderStatField) => {
  const { statusText, url, text, onClick } = props;

  return (
    <div className={styles['stat']}>
      <InlineText2>{statusText}</InlineText2>
      &nbsp;
      <Link href={url} target="_blank" onClick={onClick}>
        {text}
      </Link>
    </div>
  );
};
